module.exports = new __parcel__URL__("thermal_paper.7776edc9.glb").toString();